export default __webpack_public_path__ + "static/home-slide003-877970d7a2a792d83335bdb74d5d331c.jpg";